import React from "react";
import moment from "moment";
import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";

const DepositRefunded = ({ payment }) => {
  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        <Typography
          sx={{
            color: "#008001",
            fontWeight: "700",
            letterSpacing: "0.46px",
            marginRight: "5px",
            textTransform: "uppercase",
          }}
        >
          Refunded
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        <Typography
          sx={{
            color: "#008001",
            fontWeight: "700",
            letterSpacing: "0.46px",
            textTransform: "capitalize",
          }}
        >
          Amount:{" "}
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(payment.amount)}{" "}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        <Typography
          sx={{
            color: "#008001",
            fontWeight: "700",
            letterSpacing: "0.46px",
            textTransform: "capitalize",
          }}
        >
          Date Refund Received:{" "}
          {moment(payment.refund_status.date_received).format("DD/MM/YYYY")}
        </Typography>
      </Grid>
    </React.Fragment>
  );
};

DepositRefunded.propTypes = {
  payment: PropTypes.object,
};

export default DepositRefunded;
